import { render, staticRenderFns } from "./Apibatch.vue?vue&type=template&id=d7c2378c&"
import script from "./Apibatch.vue?vue&type=script&lang=js&"
export * from "./Apibatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports